// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1q-u8","turquoise":"Button_turquoise__2szeN","purple":"Button_purple__3aNCP","standardWidth":"Button_standardWidth__1EKpm"};